document.addEventListener("DOMContentLoaded", function () {
  // --- Variant Select Update ---
  const select = document.getElementById("variant-select");
  const mapping = {
    ".product-specification": "data-specification",
    ".description-content-ability": "data-long_description",
    ".delivery-and-setup": "data-delivery-setup",
    ".product-faq": "data-faq",
    ".standard-call-to-action": "data-standard_call_to_action",
    ".cs-short-description": "data-delivery-short_description",
  };
  function updateContent(option) {
    Object.entries(mapping).forEach(([selector, attr]) => {
      const value = option.getAttribute(attr);
      if (value) document.querySelector(selector).innerHTML = value;
    });
  }
  const initialOption = select.querySelector("option[selected]") || select.options[0];
  updateContent(initialOption);
  document.querySelectorAll(".productOption").forEach((el, idx) => {
    el.addEventListener("click", () => updateContent(select.options[idx]));
  });

  // --- Predictive Search ---
  const searchInput = document.getElementById("Search-In-Templates");
  const resultsDiv = document.querySelector(".predictive-search--results-body");
  searchInput.addEventListener("input", () => {
    resultsDiv.classList.toggle("cs-result-active", searchInput.value.trim() !== "");
  });

  // --- Hide Empty Accordions ---
  document.querySelectorAll(".product-accordion").forEach(acc => {
    if (!acc.querySelector(".product-accordion--content-body").textContent.trim()) acc.style.display = "none";
  });

  // --- Video Play/Pause ---
  const video = document.getElementById("video");
  const playBtn = document.getElementById("circle-play-b");
  playBtn.addEventListener("click", () => {
    video.paused || video.ended ? video.play() : video.pause();
  });
  video.addEventListener("playing", () => { playBtn.style.opacity = 0; playBtn.style.pointerEvents = "none"; });
  video.addEventListener("pause", () => { playBtn.style.opacity = 1; playBtn.style.pointerEvents = "auto"; });

  // --- Fancybox ---
  if (typeof Fancybox !== "undefined") {
    Fancybox.bind("[data-fancybox='gallery']", {
      Thumbs: { autoStart: true },
      Toolbar: { display: ["close"] },
      zoom: { wheel: "auto" },
    });
  }
});

$(function () {
  // --- Slider Initialization ---
  const initSlick = (selector, settings) => $(selector).slick(settings);

  // Testimonial Slider
  initSlick(".cs-testimonial-slider", {
    dots: false, arrows: false, infinite: true, speed: 500,
    slidesToShow: 1, slidesToScroll: 1, autoplay: true, autoplaySpeed: 2000
  });
  $(document).on("click", ".testimonial-swiper-button-prev", () => $(".cs-testimonial-slider").slick("slickPrev"));
  $(document).on("click", ".testimonial-swiper-button-next", () => $(".cs-testimonial-slider").slick("slickNext"));
  $(".cs-testimonial-slider").on("beforeChange", (e, slick) => $(slick.$slides).find(":focus").blur());

  // Mobile Slider
  initSlick(".mobile-slide", {
    dots: false, arrows: false, infinite: true, speed: 500,
    slidesToShow: 1, slidesToScroll: 1, autoplay: true, autoplaySpeed: 3000
  });
  $(".swiper-button-prevs").click(() => $(".is-slider").slick("slickPrev"));
  $(".swiper-button-nexts").click(() => $(".is-slider").slick("slickNext"));

  // Gallery Slider
  const $mainSlider = $(".gallery-slider");
  const $thumbSlider = $(".gallery-thumbs");
  const gallerySettings = {
    slidesToShow: 1, slidesToScroll: 1, arrows: false, fade: true, asNavFor: ".gallery-thumbs"
  };
  const thumbSettings = {
    slidesToShow: 3, slidesToScroll: 1, asNavFor: ".gallery-slider",
    dots: false, centerMode: true, focusOnSelect: true, variableWidth: true,
    prevArrow: $(".cs-swiper-button-prev"), nextArrow: $(".cs-swiper-button-next")
  };
  $mainSlider.not(".slick-initialized").slick(gallerySettings);
  $thumbSlider.not(".slick-initialized").slick(thumbSettings);

  // Synchronize active slide after init
  setTimeout(() => {
    const $active = $mainSlider.find(".gallery-image.active").first();
    if ($active.length) {
      const idx = $active.data("slick-index") ?? $mainSlider.find(".gallery-image").index($active);
      $mainSlider.slick("slickGoTo", idx);
      $thumbSlider.slick("slickGoTo", idx);
    }
  }, 200);
});
